import { render, staticRenderFns } from "./SetJson.vue?vue&type=template&id=6a36f508&scoped=true"
import script from "./SetJson.vue?vue&type=script&lang=js"
export * from "./SetJson.vue?vue&type=script&lang=js"
import style0 from "./SetJson.vue?vue&type=style&index=0&id=6a36f508&prod&lang=scss&scoped=true"
import style1 from "./SetJson.vue?vue&type=style&index=1&id=6a36f508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36f508",
  null
  
)

export default component.exports